export const ABOUT_ME = '/';
export const WEB_APPS = '/web-apps';
export const ART_GALLERY = '/art-gallery';
